
import { queryPrevNextPost } from '@/graphql/wordpress/query/post.js'

export default {
  name: 'Footer',
  props: {
    post: {
      type: Object,
      required: true,
    },
    socialData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    next: undefined,
  }),
  async fetch() {
    // Se non ci sono articoli più recenti, mostro quelli passati
    try {
      this.next = await this.$apollo
        .query({
          query: queryPrevNextPost,
          variables: {
            id: this.post?.id,
          },
        })
        .then(({ data }) =>
          data?.postBy?.next ? data?.postBy?.next : data?.postBy?.previous
        )
    } catch (e) {
      console.error(e)
      // return this.$nuxt.context.error({ statusCode: 500 })
    }
  },
}
